export default __webpack_public_path__ + "static/media/theme6.cdb541f5.png";